// extracted by mini-css-extract-plugin
export default {"root":"raKjr","amount":"UHLgN","expireDate":"WPBjn","expireDatetime":"_3iG5j"};